import React from "react";

const AboutThisPage = () => (
  <>
    {/* Hero Section */}
    <section
      className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(252, 53, 236, 1) 0%, rgba(237, 0, 170, 1) 100%)",
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        }}
      ></div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik] leading-tight">
          About This Page
        </h1>
      </div>
    </section>

    {/* About Story Section */}
    <div className="max-w-5xl mx-auto py-16 px-6 text-gray-800">
      <h2 className="text-3xl font-extrabold mb-6 text-main-pink">
        The Day My Daughter Inspired Me
      </h2>

      <p className="text-base leading-relaxed mb-4">
        I’ve been called a lot of things in my life — doctor, scientist, artist, strategist,
        economist, builder of companies...
      </p>

      <p className="text-base leading-relaxed mb-4">
        But if I had to choose one title I’d keep forever, it would be this:
        <span className="block font-bold italic text-main-pink mt-2">The Godfather of Creativity. 😎</span>
      </p>

      <p className="text-base leading-relaxed mb-4">
        And yet, for all the systems I’ve designed, brands I’ve launched, and empires I’ve built…
        nothing quite prepared me for the fire and purpose I saw in my daughter, Roshelle.
      </p>

      <p className="text-base leading-relaxed mb-4">
        She’s a force. A woman who’s lived through storms. A woman who doesn’t just care — she does
        something about it. From her degree in Gender Studies to real-world battles that no diploma
        can teach, she became the kind of person women turn to when things get hard. Legal problems,
        family breakdowns, housing messes, business setbacks — she’s walked beside so many, with grace and grit.
      </p>

      <p className="text-base leading-relaxed mb-4">
        And I kept telling her:
        <span className="block italic text-main-pink mt-2">
          “Roshelle, this isn’t just empathy. This is infrastructure. Build it.”
        </span>
      </p>

      <p className="text-base leading-relaxed mb-4">
        One day, she looked at me and said,
        <span className="block italic font-semibold text-main-pink mt-2">
          “Let’s build it, Dad!”
        </span>
      </p>

      <p className="text-base leading-relaxed mb-6">
        That’s how Pink Help was born — not from strategy decks or investor decks, but from her story,
        her resilience, and her refusal to let another woman feel alone.
      </p>

      <p className="text-lg font-semibold text-gray-800">
        This is her page.<br />
        I just had the privilege of standing beside her when the idea caught fire.
      </p>

      <p className="mt-6 font-semibold text-main-pink text-lg">
        — Dr. S.F. Czar<br />
        (Proud Father, and Co-Creator)
      </p>
    </div>
  </>
);

export default AboutThisPage;
